import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { CouponType } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Delete Course coupon
 * @param course_id
 * @param version
 * @param coupon_id
 */
const deleteCourseCoupons = (
  course_id: string | string[],
  version: number,
  coupon_id: string
): Promise<CouponType[]> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE + course_id + '/' + version + '/coupons/' + coupon_id
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.delete(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default deleteCourseCoupons
